<template>
  <el-dialog title="养护日报" width="930px" :visible="isShow" :close-on-click-modal="false" @close="closeDialog">
    <el-tabs v-if="this.dailyId.length > 1" v-model="activeTab" @tab-click="handleTabClick">
      <el-tab-pane v-for="(id, index) in dailyId" :key="id" :name="String(index)">
        <span slot="label">
          日报{{ index + 1 }}
        </span>
      </el-tab-pane>
    </el-tabs>
    <div class="content">
      <div class="head">
        <div class="title">
          <p class="name">{{ info.projectName || '--' }}</p>
          <p>{{ info.dailyDate ? info.dailyDate.replace('-', '年').replace('-', '月') + '日' : '' }}</p>
        </div>
        <div class="manageUserList">
          <span class="label">现场管理员</span>
          <p class="m-item" v-for="(item, ind) in info.manageUserList || []" :key="'m' + ind">
            <img v-if="item.file" :src="item.file" alt="">
            <img v-else src="@/assets/img/workPlan/default.png" alt="">
            <span>{{ item.manageUserName || '--' }}</span>
          </p>
        </div>
      </div>
      <div class="ctt-list">
        <template v-if="sectionList.includes('2')">
          <p class="section-title">养护作业</p>
          <template v-if="info.dailyWorkList && info.dailyWorkList.length">
            <div class="section-ctt section-flex">
              <div class="section-ctt-item" v-for="(item, ind) in info.dailyWorkList" :key="'d' + ind">
                <p v-if="item.taskId" class="typeTip">养护计划任务</p>
                <p>作业内容</p>
                <p class="limit">{{ item.taskNotes || '' }}</p>
                <div class="fileList">
                  <div class="fileBlock" v-for="(items, index) in item.fileList" :key="index">
                    <el-image v-if="imgTypeList.find(itemx => itemx === items.fileType)"
                      :src="items.filePrefix + items.fileUrl" :preview-src-list="item.fileList | imgListFormat"
                      fit="fill">
                    </el-image>
                    <video v-if="videoTypeList.find((itemx) => itemx === items.fileType)" controls="controls"
                      :src="items.filePrefix + items.fileUrl" :preview-src-list="[items.filePrefix + items.fileUrl]"
                      fit="fill">
                    </video>
                  </div>
                </div>
                <p>备注：{{ item.workNotes || '无' }}</p>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="noData">
              <img src="../../assets/img/workPlan/noData.png" alt="">
            </div>
          </template>
        </template>
        <template v-if="sectionList.includes('6')">
          <p class="section-title">任务工单</p>
          <template v-if="workList && workList.length">
            <div class="section-ctt section-flex">
              <div class="section-ctt-item" v-for="(item, ind) in workList" :key="'w' + ind">
                <p v-if="item.dailyId" class="tip">养护计划任务</p>
                <p>作业内容</p>
                <p class="limit">{{ item.orderNotes || '' }}</p>
                <div class="fileList">
                  <div class="fileBlock" v-for="(items, index) in item.fileList" :key="index">
                    <el-image v-if="imgTypeList.find(itemx => itemx === items.fileType)"
                      :src="items.filePrefix + items.fileUrl" :preview-src-list="item.fileList | imgListFormat"
                      fit="fill">
                    </el-image>
                    <video v-if="videoTypeList.find((itemx) => itemx === items.fileType)" controls="controls"
                      :src="items.filePrefix + items.fileUrl" :preview-src-list="[items.filePrefix + items.fileUrl]"
                      fit="fill">
                    </video>
                    <img v-if="items.objectId !== item.orderId" class="fileTip" src="../../assets/img/workPlan/tip.png"
                      alt="">
                  </div>
                </div>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="noData">
              <img src="../../assets/img/workPlan/noData.png" alt="">
            </div>
          </template>
        </template>
        <template v-if="sectionList.includes('1')">
          <p class="section-title">劳务考勤</p>
          <template v-if="labourList && labourList.length">
            <div class="section-ctt">
              <div class="section-ctt-item section-ctt-item-flex">
                <div class="labourLeft">
                  <div ref="labourChart" class="labourChart"></div>
                  <div class="tipList">
                    <div class="tipListItem" v-for="(item, ind) in labourInfo" :key="'l' + ind">
                      <img :src="item.img" alt="">
                      <span>{{ item.name }}</span>
                      <span>：{{ item.value }}{{ item.unit }}</span>
                    </div>
                  </div>
                </div>
                <div class="labourRight">
                  <el-table class="global-table" :data="labourList" border :max-height="180">
                    <el-table-column label="班组/工人" show-overflow-tooltip prop="teamName" min-width="200">
                      <template v-slot="{ row }">
                        {{ row.teamName || '--' }}
                      </template>
                    </el-table-column>
                    <el-table-column label="上班签到" prop="onSignNum">
                      <template v-slot="{ row }">
                        {{ row.onSignNum || '0' }}人
                      </template>
                    </el-table-column>
                    <el-table-column label="下班签到" prop="offSignNum">
                      <template v-slot="{ row }">
                        {{ row.offSignNum || '0' }}人
                      </template>
                    </el-table-column>
                    <el-table-column label="签到情况" show-overflow-tooltip prop="signStatus">
                      <template v-slot="{ row }">
                        <span :class="{ error: row.signStatus !== '1' }">{{ row.signStatus === '1' ? '正常' : '异常'
                        }}</span>
                      </template>
                    </el-table-column>
                  </el-table>
                  <p>考勤照片：</p>
                  <div class="fileList">
                    <div class="fileBlock" v-for="(items, index) in signImgList" :key="index">
                      <el-image :src="items" :preview-src-list="signImgList" fit="fill"></el-image>
                    </div>
                  </div>
                </div>
              </div>
              <div class="section-ctt-item section-ctt-item-flex">
                <div class="labourLeft">
                  <div class="tipList orange">
                    <div class="tipListItem" v-for="(item, ind) in labourInfo2" :key="'l' + ind">
                      <img :src="item.img" alt="">
                      <span>{{ item.name }}</span>
                      <span>：{{ item.value }}{{ item.unit }}</span>
                    </div>
                  </div>
                </div>
                <div class="labourRight">
                  <el-table class="global-table" :data="labourList" border :max-height="180">
                    <el-table-column label="班组/工人" show-overflow-tooltip prop="teamName" min-width="200">
                      <template v-slot="{ row }">
                        {{ row.teamName || '--' }}
                      </template>
                    </el-table-column>
                    <el-table-column label="加班人数" prop="overtimeNum">
                      <template v-slot="{ row }">
                        {{ row.overtimeNum || '0' }}人
                      </template>
                    </el-table-column>
                    <el-table-column label="加班时长" prop="overtimeHours">
                      <template v-slot="{ row }">
                        {{ row.overtimeHours || '0' }}小时
                      </template>
                    </el-table-column>
                    <el-table-column label="合计时长" prop="totalOvertimeHours">
                      <template v-slot="{ row }">
                        {{ row.totalOvertimeHours || '0' }}小时
                      </template>
                    </el-table-column>
                  </el-table>
                  <p>考勤照片：</p>
                  <div class="fileList">
                    <div class="fileBlock" v-for="(items, index) in overtimeImgList" :key="index">
                      <el-image :src="items" :preview-src-list="overtimeImgList" fit="fill"></el-image>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="noData">
              <img src="../../assets/img/workPlan/noData.png" alt="">
            </div>
          </template>
        </template>
        <template v-if="sectionList.includes('4')">
          <p class="section-title">机械台班</p>
          <template v-if="machineList && machineList.length">
            <div class="section-ctt section-flex-line">
              <div class="section-ctt-item" v-for="(item, ind) in machineList" :key="'d' + ind">
                <p class="machineName">{{ item.machineryName || ' ' }}</p>
                <div class="inline">
                  <p class="tag">型号：{{ item.specificationModel || '' }}</p>
                  <p v-if="item.whetherOilName" class="tag">含油</p>
                  <p class="tag">{{ item.supplierName || '' }}</p>
                </div>
                <div class="inline w50">
                  <p>台班/小时数：{{ item.hours || '' }}</p>
                  <p>台班金额（元）：{{ item.price || '' }}</p>
                </div>
                <div class="inline">
                  <p>作业内容：</p>
                  <p class="limit">{{ item.jobContent || '' }}</p>
                </div>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="noData">
              <img src="../../assets/img/workPlan/noData.png" alt="">
            </div>
          </template>
        </template>
        <template v-if="sectionList.includes('3')">
          <p class="section-title">物料信息</p>
          <template v-if="(detailedList && detailedList.length) || (detailedOutList && detailedOutList.length)">
            <div class="section-ctt section-flex">
              <div class="section-ctt-item h245" v-if="detailedOutList && detailedOutList.length">
                <div class="tab-list">
                  <div class="tab-item" v-for="(item, ind) in tabOutList" @click="tabOutIndex = ind" :key="'to' + ind">
                    <span :class="{ gray: ind !== tabOutIndex }">{{ item }}</span>
                  </div>
                </div>
                <div v-show="tabOutIndex === 0" class="item-ctt-flex">
                  <div ref="detailedOutChart" class="detailedOutChart"></div>
                  <div class="tipList">
                    <div class="tipListItem" v-for="(item, ind) in detailedOutInfo" :key="'di' + ind">
                      <i class="icon"></i>
                      <span>{{ item.name }}</span>
                      <span>：{{ item.value }}</span>
                    </div>
                  </div>
                </div>
                <el-table v-show="tabOutIndex === 1" class="global-table" :data="detailedOutList" border
                  :max-height="180">
                  <el-table-column label="产品名称" show-overflow-tooltip prop="materialName" min-width="100">
                    <template v-slot="{ row }">
                      {{ row.materialName || '--' }}
                    </template>
                  </el-table-column>
                  <el-table-column label="出库数量" prop="operationStock">
                    <template v-slot="{ row }">
                      {{ row.operationStock || '0' }}
                    </template>
                  </el-table-column>
                  <el-table-column label="用途说明" show-overflow-tooltip prop="bak" min-width="100">
                    <template v-slot="{ row }">
                      {{ row.bak || '--' }}
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <div class="section-ctt-item" v-if="detailedList && detailedList.length">
                <div class="tab-list">
                  <div class="tab-item" v-for="(item, ind) in tabList" @click="tabIndex = ind" :key="'to' + ind">
                    <span :class="{ gray: ind !== tabIndex }">{{ item }}</span>
                  </div>
                </div>
                <div v-show="tabIndex === 0" class="item-ctt-flex">
                  <div ref="detailedChart" class="detailedChart"></div>
                  <div class="tipList">
                    <div class="tipListItem" v-for="(item, ind) in detailedInfo" :key="'di' + ind">
                      <i class="icon"></i>
                      <span>{{ item.name }}</span>
                      <span>：{{ item.value }}</span>
                    </div>
                  </div>
                </div>
                <el-table v-show="tabIndex === 1" class="global-table" :data="detailedList" border :max-height="180">
                  <el-table-column label="产品名称" show-overflow-tooltip prop="materialName" min-width="100">
                    <template v-slot="{ row }">
                      {{ row.materialName || '--' }}
                    </template>
                  </el-table-column>
                  <el-table-column label="入库数量" prop="operationStock">
                    <template v-slot="{ row }">
                      {{ row.operationStock || '0' }}
                    </template>
                  </el-table-column>
                  <el-table-column label="入库仓库" show-overflow-tooltip prop="warehouseName" min-width="100">
                    <template v-slot="{ row }">
                      {{ row.warehouseName || '--' }}
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="noData">
              <img src="../../assets/img/workPlan/noData.png" alt="">
            </div>
          </template>
        </template>
        <template v-if="sectionList.includes('5')">
          <p class="section-title">其他事项</p>
          <template v-if="info.dailyBak">
            <div class="section-ctt">
              <div class="section-ctt-item">
                <p>{{ info.dailyBak }}</p>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="noData">
              <img src="../../assets/img/workPlan/noData.png" alt="">
            </div>
          </template>
        </template>
        <p class="section-title">客户评价</p>
        <div class="section-ctt">
          <div class="section-ctt-item">
            <div class="inline-center">
              <p>客户评价：</p>
              <div class="startList" :class="'start' + Math.round(Number(info.avgGrade) || 5)">
                <i class="icon-start"></i>
                <i class="icon-start"></i>
                <i class="icon-start"></i>
                <i class="icon-start"></i>
                <i class="icon-start"></i>
              </div>
              <p class="num">{{ info.avgGrade || 5 }}</p>
            </div>
            <div class="appraise-list" v-if="appraiseList && appraiseList.length">
              <div class="appraise-item" v-for="(item, ind) in appraiseList" :key="'a' + ind">
                <img v-if="item.avatar" :src="item.avatar" alt="">
                <img v-else src="../../assets/img/workPlan/default.png" alt="">
                <div class="appraise-item-ctt">
                  <div class="appraise-item-ctt-name">
                    <p class="nickName">{{ item.nickName || ' ' }}</p>
                    <div class="inline-center">
                      <div class="startList" :class="'start' + Math.round(Number(item.grade) || 5)">
                        <i class="icon-start"></i>
                        <i class="icon-start"></i>
                        <i class="icon-start"></i>
                        <i class="icon-start"></i>
                        <i class="icon-start"></i>
                      </div>
                      <p class="num">{{ item.grade || 5 }}</p>
                    </div>
                  </div>
                  <p>{{ item.content || '暂无评价' }}</p>
                  <p class="time">{{ item.ctime || '' }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
// import * as echarts from 'echarts'
export default {
  name: 'ReportDetail',
  props: {
    dailyId: {
      type: Array,
      default: []
    },
    otherProjectId: {
      type: String,
      default: ''
    },
    isShow: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    projectId() {
      return this.otherProjectId || this.$store.state.projectId
    }
  },
  filters: {
    imgListFormat(list) {
      const imgTypeList = ['jpeg', 'jpg', 'png']
      const imgList = []
      list.forEach((item) => {
        if (imgTypeList.find((items) => items === item.fileType)) {
          imgList.push(item.filePrefix + item.fileUrl)
        }
      })
      return imgList || []
    }
  },
  watch: {
    isShow(val) {
      if (val) {
        this.loadData()
      }
    }
  },
  data() {
    return {
      imgTypeList: ['jpeg', 'jpg', 'png'],
      videoTypeList: ['mp4', 'mov'],
      // 日报详情、2-养护作业、5-其他事项
      info: {},
      // 模块展示配置
      sectionList: [],
      // 养护作业
      workList: [],
      // 劳务考勤 -- begin
      labourInfo: [],
      labourInfo2: [],
      labourList: [],
      signImgList: [],
      overtimeImgList: [],
      // 劳务考勤 -- end
      // 机械台班
      machineList: [],
      // 物料信息 -- begin
      tabList: ['验收入库', '入库详情'],
      tabIndex: 0,
      detailedInfo: [],
      detailedList: [],
      tabOutList: ['物料领用', '领用详情'],
      tabOutIndex: 0,
      detailedOutInfo: [],
      detailedOutList: [],
      // 物料信息 -- end
      // 客户评价
      appraiseList: [],
      activeTab: 0
    }
  },
  created() {
  },
  destroyed() {
    this._chartlabourChart && this._chartlabourChart.clear()
    this._chartdetailedOutChart && this._chartdetailedOutChart.clear()
    this._chartdetailedChart && this._chartdetailedChart.clear()
  },
  methods: {
    loadData() {
      this.loadDetail()
      this.loadAppraise()
    },
    handleTabClick(tab) {
      this.loadData()
    },
    // 日报详情、2-养护作业、5-其他事项
    loadDetail() {
      const currentId = this.dailyId[this.activeTab]
      this.$axios.get(this.$apis.workPlan.selectYhProjectDailyByDailyId, {
        dailyId: currentId
      }).then(res => {
        this.info = res || {}
        const sList = this.info.dailyOptionIds || []
        if (sList && sList.length) {
          if (sList.includes('1')) {
            this.loadLabour()
          }
          if (sList.includes('3')) {
            this.loadDetailed()
            this.loadDetailedCheckOut()
          }
          if (sList.includes('4')) {
            this.loadMachine()
          }
          if (sList.includes('6')) {
            this.loadOrder()
          }
        }
        this.sectionList = [...sList]
      })
    },
    // 1 劳务考勤
    loadLabour() {
      this.$axios.get(this.$apis.workPlan.selectLabourServiceStatisticByDaily, {
        projectId: this.projectId,
        attendanceDate: this.info.dailyDate
      }).then(res => {
        console.log('loadLabour', res)
        this.labourList = res.attendanceList || []
        this.signImgList = res.signImgList || []
        this.overtimeImgList = res.overtimeImgList || []
        if (this.labourList && this.labourList.length) {
          this.labourInfo = [{
            img: require('../../assets/img/workPlan/cq.png'),
            value: res.attendanceTotal || 0,
            name: '出勤总人数',
            unit: '人'
          }, {
            img: require('../../assets/img/workPlan/sm.png'),
            value: res.realNameTotal || 0,
            name: '实名验工',
            unit: '人'
          }, {
            img: require('../../assets/img/workPlan/ai.png'),
            value: res.aiTotal || 0,
            name: 'AI人员计数',
            unit: '人'
          }]
          const data = this.labourInfo.slice(1)
          this.renderEchart('labourChart', data, res.attendanceTotal || 0)
          this.labourInfo2 = [{
            img: require('../../assets/img/workPlan/jb-num.png'),
            value: res.overtimeTotal || 0,
            name: '加班总人数',
            unit: '人'
          }, {
            img: require('../../assets/img/workPlan/jb-time.png'),
            value: res.overtimeHoursTotal || 0,
            name: '加班总时长',
            unit: '小时'
          }]
        }
      })
    },
    // 3 物料信息 - 入库
    loadDetailed() {
      this.$axios.get(this.$apis.workPlan.selectYhDetailedDaily, {
        projectId: this.projectId,
        storageDate: this.info.dailyDate
      }).then(res => {
        this.detailedList = res.yhDetailedList || []
        this.detailedInfo = []
        const obj = res.typeMap || {}
        for (const key in obj) {
          this.detailedInfo.push({
            value: obj[key],
            name: key
          })
        }
        if (this.detailedInfo && this.detailedInfo.length) {
          this.renderEchart('detailedChart', this.detailedInfo)
        }
        console.log('loadDetailed', res)
      })
    },
    // 3 物料信息 - 出库
    loadDetailedCheckOut() {
      this.$axios.get(this.$apis.workPlan.selectYhDetailedDaily, {
        projectId: this.projectId,
        checkoutDate: this.info.dailyDate
      }).then(res => {
        this.detailedOutList = res.yhDetailedList || []
        this.detailedOutInfo = []
        const obj = res.typeMap || {}
        for (const key in obj) {
          this.detailedOutInfo.push({
            value: obj[key],
            name: key
          })
        }
        if (this.detailedOutInfo && this.detailedOutInfo.length) {
          this.renderEchart('detailedOutChart', this.detailedOutInfo)
        }
        console.log('loadDetailedCheckOut', res)
      })
    },
    // 4 台班劳务
    loadMachine() {
      this.$axios.get(this.$apis.workPlan.selectYhMachineTeamLineByList, {
        projectId: this.projectId,
        machineTeamDate: this.info.dailyDate
      }).then(res => {
        this.machineList = res.list || []
        console.log('loadMachine', res.list || [])
      })
    },
    // 6任务工单
    loadOrder() {
      this.$axios.get(this.$apis.workPlan.selectDailyOrder, {
        projectId: this.projectId,
        date: this.info.dailyDate
      }).then(res => {
        this.workList = res || []
      })
    },
    // 客户评价
    loadAppraise() {
      const currentId = this.dailyId[this.activeTab]
      this.$axios.get(this.$apis.workPlan.selectYhAppraiseByList, {
        objectId: currentId
      }).then(res => {
        this.appraiseList = res.list || []
        console.log('loadAppraise', res.list || [])
      })
    },
    renderEchart(ele, data, total) {
      this.$nextTick(() => {
        this['_chart' + ele] = echarts.init(this.$refs[ele])
        const option = {
          title: total
            ? {
              text: total,
              subtext: '出勤总人数',
              left: 'center',
              top: '38%',
              show: true,
              textStyle: {
                align: 'center',
                color: '#000000',
                fontSize: 14,
                fontFamily: 'PingFangSC, PingFang SC'
              },
              subtextStyle: {
                align: 'center',
                fontSize: 14,
                color: '#000000',
                fontFamily: 'PingFangSC, PingFang SC'
              }
            }
            : {},
          series: [{
            name: '',
            type: 'pie',
            clockWise: false,
            radius: ['66%', '84%'],
            label: {
              show: false
            },
            labelLine: {
              show: false
            },
            itemStyle: {
            },
            hoverAnimation: false,
            data: data
          }, {
            name: '',
            type: 'pie',
            zlevel: -1,
            clockWise: false,
            radius: ['60%', '90%'],
            itemStyle: {
              color: 'rgba(29, 93, 244, 0.2)'
            },
            label: {
              show: false
            },
            labelLine: {
              show: false
            },
            hoverAnimation: false,
            data: [{
              value: 100
            }]
          }]
        }
        this['_chart' + ele].clear()
        this['_chart' + ele].setOption(option)
      })
    },
    // 关闭
    closeDialog() {
      this.$emit('update:isShow', false)
    }
  }
}
</script>

<style scoped lang="scss">
.el-tabs {
  margin: -20px 0 0 0;
}


::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

/*定义滚动条的轨道，内阴影及圆角*/
::-webkit-scrollbar-track {}

/*定义滑块，内阴影及圆角*/
::-webkit-scrollbar-thumb {
  border-radius: 3px;
  background: #2275D3;
}

.error {
  color: #FF0000;
}

.mb10 {
  margin-bottom: 10px;
}

.h245 {
  height: 245px;
}

.content {
  .ctt-list {
    margin-top: 14px;
    max-height: calc(100vh - 460px);
    overflow-y: auto;
  }

  .head {
    width: 100%;
    height: 93px;
    font-family: PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: #000000;
    padding: 18px 20px 10px 20px;
    background: url("../../assets/img/workPlan/bg.png") no-repeat center /cover;

    .title {
      display: flex;
      justify-content: space-between;
      margin-bottom: 12px;

      .name {
        font-size: 20px;
      }
    }

    .manageUserList {
      display: flex;
      align-items: center;

      .label {
        margin-right: 20px;
      }

      .m-item {
        display: flex;
        align-items: center;
        margin-right: 30px;

        img {
          width: 24px;
          height: 24px;
          border: 2px solid #ffffff;
          border-radius: 50%;
          margin-right: 10px;
        }
      }
    }
  }

  .section-title {
    position: relative;
    font-family: PingFang SC;
    font-weight: 400;
    font-size: 12px;
    color: #0040FF;
    padding: 0px 9px 14px;

    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: calc(50% - 12px);
      width: 4px;
      height: 10px;
      background: #0040FF;
    }
  }

  .section-ctt {
    .section-ctt-item {
      position: relative;
      padding: 10px 18px;
      border: 1px solid #EBEBEB;
      margin-bottom: 14px;

      p {
        font-family: PingFang SC;
        font-weight: 400;
        font-size: 12px;
        color: #000000;
        line-height: 18px;
        margin-bottom: 10px;

        &.limit {
          height: 36px;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }

      .fileList {
        display: flex;
        flex-wrap: nowrap;
        width: calc(100% + 10px);
        overflow-x: auto;
        overflow-y: hidden;
        margin-bottom: 10px;
      }

      .fileBlock {
        position: relative;
        width: 70px;
        height: 70px;
        flex-shrink: 0;
        margin: 0 10px 2px 0;

        .el-image {
          width: 100%;
          height: 100%;
        }

        video {
          width: 100%;
          height: 100%;
        }

        .fileTip {
          position: absolute;
          top: 0;
          right: 0;
          width: 34px;
          height: 34px;
          z-index: 2;
        }
      }

      .typeTip {
        position: absolute;
        top: 10px;
        right: 0px;
        width: 92px;
        height: 18px;
        color: #FFFFFF;
        background: #53BFBE;
        padding-left: 10px;

        &::before {
          content: '';
          position: absolute;
          left: -2px;
          width: 8px;
          height: 18px;
          background: #53BFBE;
          transform: skewX(-10deg);
        }
      }

      .tipList {
        width: 156px;
        height: auto;
        padding: 5px 5px 10px 10px;
        background: #F9FCFF;
        border-radius: 10px;
        border: 1px solid #D1E5FA;

        .tipListItem {
          display: flex;
          align-items: center;

          .icon {
            flex-shrink: 0;
            width: 6px;
            height: 6px;
            background: #1B85FF;
            border-radius: 50%;
            margin-right: 10px;
          }

          span {
            font-family: PingFang SC;
            font-weight: 400;
            font-size: 12px;
            color: #000000;
            line-height: 30px;
            flex-shrink: 0;

            &:nth-child(2) {
              flex-shrink: 1;
              word-break: keep-all;
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
            }
          }

          img {
            flex-shrink: 0;
            width: 14px;
            height: 16px;
            margin-right: 12px;
          }
        }
      }

      .machineName {
        font-family: PingFang SC;
        font-weight: 600;
        font-size: 14px;
        color: #000000;
      }

      .inline {
        display: flex;

        .tag {
          flex-shrink: 0;
          height: 24px;
          font-family: PingFang SC;
          font-weight: 400;
          font-size: 12px;
          color: #000000;
          line-height: 24px;
          word-break: keep-all;
          white-space: nowrap;
          text-overflow: ellipsis;
          padding: 0 10px;
          background: #F4F4F4;
          margin-right: 10px;
          overflow: hidden;

          &:last-child {
            flex-shrink: 1;
            margin-right: 0;
          }
        }

        &.w50 {
          p {
            width: 50%;
          }
        }
      }

      .inline-center {
        display: flex;
        align-items: center;
        margin-bottom: 10px;

        p {
          font-size: 14px;
          margin-bottom: 0;

          &.num {
            font-family: DIN-BlackItalic;
            font-size: 20px;
            color: #000000;
            margin-left: 10px;
          }
        }

        .startList {
          display: flex;
          align-items: center;

          .icon-start {
            width: 30px;
            height: 30px;
            background: url('../../assets/img/workPlan/star5.png') no-repeat center 5px/ 20px 18px;
          }

          &.start5 {
            .icon-start {
              background: url('../../assets/img/workPlan/star1.png') no-repeat center center/ 29px 28px;
            }
          }

          &.start4 {
            .icon-start:not(:last-child) {
              background: url('../../assets/img/workPlan/star1.png') no-repeat center center/ 29px 28px;
            }
          }

          &.start3 {
            .icon-start {

              &:nth-child(1),
              &:nth-child(2),
              &:nth-child(3) {
                background: url('../../assets/img/workPlan/star2.png') no-repeat center center/ 30px 28px;
              }
            }
          }

          &.start2 {
            .icon-start {

              &:nth-child(1),
              &:nth-child(2) {
                background: url('../../assets/img/workPlan/star3.png') no-repeat center center/ 29px 28px;
              }
            }
          }

          &.start1 {
            .icon-start:first-child {
              background: url('../../assets/img/workPlan/star4.png') no-repeat center center/ 30px 28px;
            }
          }
        }
      }

      .tab-list {
        display: flex;
        align-items: center;
        margin-bottom: 14px;

        .tab-item {
          padding-right: 12px;
          cursor: pointer;

          span {
            font-family: PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #000000;

            &.gray {
              color: #999999;
            }
          }

          &:not(:first-child) {
            position: relative;
            padding-left: 14px;

            &::before {
              content: "";
              width: 2px;
              height: 10px;
              position: absolute;
              left: 0;
              top: calc(50% - 5px);
              background: #BBBBBB;
            }
          }
        }
      }

      .appraise-list {

        /* max-height: 250px; */
        .appraise-item {
          display: flex;
          justify-content: space-between;
          margin-top: 14px;

          img {
            width: 30px;
            height: 30px;
            border-radius: 50%;
          }

          .appraise-item-ctt {
            width: calc(100% - 45px);
            border-bottom: 1px solid #EAEAEA;

            .appraise-item-ctt-name {
              display: flex;
              justify-content: space-between;

              .nickName {
                font-family: PingFang SC;
                font-weight: 400;
                font-size: 14px;
                color: #000000;
                margin-bottom: 0;
              }

              .inline-center {
                margin-bottom: 0;

                .num {
                  font-family: PingFang SC;
                  font-weight: 600;
                  font-size: 14px;
                  color: #000000;
                }
              }
            }

            .time {
              color: #999999;
              margin-bottom: 18px;
            }
          }

          &:last-child .appraise-item-ctt {
            border-bottom-width: 0;
          }
        }
      }

      &.section-ctt-item-flex {
        display: flex;
        justify-content: space-between;
        padding: 20px 20px 10px 10px;
      }

      .labourLeft {
        width: 160px;

        .labourChart {
          width: 160px;
          height: 160px;
          margin-bottom: 10px;
        }

        .tipList {
          .tipListItem:first-child img {
            width: 17px;
            height: 13px;
            margin-right: 10px;
          }

          &.orange {
            background: #FFF8F2;
            border: 1px solid #FAE5D1;

            & .tipListItem:nth-child(2) {
              img {
                width: 16px;
              }
            }
          }
        }
      }

      .labourRight {
        width: 684px;

        .global-table {
          margin-bottom: 20px;
        }

        .fileBlock {
          margin-bottom: 10px;
        }
      }

      .item-ctt-flex {
        display: flex;
        justify-content: space-around;
        align-items: center;
        padding-top: 14px;

        .tipList {
          height: auto;
          max-height: 160px;
          overflow-y: auto;
        }
      }

      .detailedChart,
      .detailedOutChart {
        width: 160px;
        height: 160px;
      }
    }

    &.section-flex {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;

      .section-ctt-item {
        width: calc(50% - 5px);
      }
    }

    &.section-flex-line {
      display: flex;
      overflow-x: auto;

      .section-ctt-item {
        width: 415px;
        flex-shrink: 0;
        margin-right: 10px;
      }
    }
  }

  .noData {
    width: 100%;
    height: 180px;
    text-align: center;
    padding-top: 5px;

    img {
      width: 140px;
      height: 171px;
    }
  }
}
</style>
